module.exports = __webpack_public_path__ + "static/finelite_body_img1-eccd0fa0424a37d236f21dace100ac04.png";